import React, { useState, Fragment, useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import DatosGeneralesModal from './DatosGeneralesModal'
import TabsModal from './tabsModal'
import Mensajes from '../../mensajes'

const ModalPrincipal = ({
  ID,
  formik,
  setReclama,
  isImplicado,
  setRutConductorFinal,
  setRutPropietarioFinal,
  setPaisImplicadoFinal, setShowToast, showToast,
  handleShowProp,
  setHandleShowProp, handleClose, stateChkConductor, setStateChkConductor, stateChkPropietario, setStateChkPropietario, setIdCiudadImplicado
}) => {
  const dispatch = useDispatch()
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { respuestaImplicado, respuestaAddImplicado } = data_datos_implicado
  const [tipoInvolucradoTmp, setTipoInvolucradoTmp] = useState("")

  const handleCloseToast = () => {
    setShowToast(false);
    if (respuestaAddImplicado?.respuestaAddImplicado?.code === 1 || respuestaImplicado?.respuestaImplicado?.code === 1) {
      handleClose();
    }    
  }
  useEffect(() => {
    if (tipoInvolucradoTmp != 205001) {
      setStateChkConductor(false);
      setStateChkPropietario(false);
    }
  }, [tipoInvolucradoTmp])
  return (
    <>

      <DatosGeneralesModal
        formik={formik}
        ID={ID}
        setReclama={setReclama}
        isImplicado={isImplicado}
        setTipoInvolucradoTmp={setTipoInvolucradoTmp}
      />

      <TabsModal
        formik={formik}
        isImplicado={isImplicado}
        setRutConductorFinal={setRutConductorFinal}
        setRutPropietarioFinal={setRutPropietarioFinal}
        setPaisImplicadoFinal={setPaisImplicadoFinal}
        handleShowProp={handleShowProp}
        setHandleShowProp={setHandleShowProp}
        tipoInvolucradoTmp={tipoInvolucradoTmp}
        stateChkConductor={stateChkConductor}
        setStateChkConductor={setStateChkConductor}
        stateChkPropietario={stateChkPropietario}
        setStateChkPropietario={setStateChkPropietario}
        setIdCiudadImplicado={setIdCiudadImplicado}
      />
      <Container>      
        {!isImplicado ?
        <Row>
          <Col>
            {respuestaImplicado && 
                <Mensajes
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    delay={3000}
                    responseData={respuestaImplicado.respuestaImplicado}
                ></Mensajes>
            }
          </Col>
        </Row> : 
        <Row>
          <Col>
            {respuestaAddImplicado && 
                <Mensajes
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    delay={3000}
                    responseData={respuestaAddImplicado.respuestaAddImplicado}
                ></Mensajes>
            }
          </Col>
        </Row>
        } 
      </Container>
      {/* </Form> */}
    </>
  )
}

export default ModalPrincipal
